import { ColorCodedEmployee } from 'src/components/Timeoff/widgets/TeamWidget/TeamWidgetSection';
import { TeamRequest } from '../../hooks/useGetTeamRequests';
import { isMobile } from 'react-device-detect';

export const teamVacationRequestMapper = (
  requests: Array<TeamRequest>,
  team: Array<ColorCodedEmployee>
) => {
  return requests.map((request) => {
    const teamMember = team.find(
      (member) => member.new_employeeid === request._new_employee_value
    );
    return {
      name: teamMember?.new_name,
      employeeId: request._new_employee_value,
      startDate: !isMobile
        ? request.new_startdate.replace(/-/g, ',')
        : request.new_startdate,
      endDate: !isMobile
        ? request.new_enddate.replace(/-/g, ',')
        : request.new_enddate,
      colorPersona: teamMember?.colorPersona,
      backgroundPersona: teamMember?.backgroundPersona,
    };
  });
};
